import { BaseModel } from './base-model';

export interface User {
  id?: number | null;
  rolUsuarioId: number | null;
  name?: string;
  email?: string;
  password?: string;
  rememberToken?: string;
  image?: string;
  registrador?: number;
  fechaRegistro?: string;
  fechaActualizacion?: string;
  estado?: string;
  personaDetalle?: Persona;
  personaRucDetalle?: Persona;
  empresaDetalle?: Empresa;
}

export class Usuario extends BaseModel implements User {
  rolUsuarioId: number | null = null;
  name?: string;
  email?: string;
  password?: string;
  rememberToken?: string;
  image?: string;
  registrador?: number;
  fechaRegistro?: string;
  fechaActualizacion?: string;
  estado?: string;
  personaDetalle?: Persona;
  personaRucDetalle?: Persona;
  empresaDetalle?: Empresa;

  constructor(object?: any) {
    super(object);
    if (object) {
      if (object.personaDetalle) {
        this.personaDetalle = new Persona(object.personaDetalle);
      }
      if (object.personaRucDetalle) {
        this.personaRucDetalle = new Persona(object.personaRucDetalle);
      }
      if (object.empresaDetalle) {
        this.empresaDetalle = new Empresa(object.empresaDetalle);
      }
    }
  }

  get fullName(): string {
    if (this.personaDetalle) {
      return `${this.personaDetalle.nombres} ${this.personaDetalle.apellidos}`;
    } else if (this.personaRucDetalle) {
      return `${this.personaRucDetalle.nombres} ${this.personaRucDetalle.apellidos}`;
    } else if (this.empresaDetalle) {
      return `${this.empresaDetalle.nombre}`;
    } else {
      return '';
    }
  }

  get nameOnly(): string {
    if (this.personaDetalle) {
      return `${this.personaDetalle.nombres}`;
    } else if (this.personaRucDetalle) {
      return `${this.personaRucDetalle.nombres}`;
    } else if (this.empresaDetalle) {
      return `${this.empresaDetalle.nombre}`;
    } else {
      return '';
    }
  }

  get celular(): string {
    if (this.personaDetalle) {
      return `${this.personaDetalle.celular}`;
    } else if (this.personaRucDetalle) {
      return `${this.personaRucDetalle.celular}`;
    } else if (this.empresaDetalle) {
      return `${this.empresaDetalle.celular}`;
    } else {
      return '';
    }
  }
}

export class Persona extends BaseModel {
  dni?: string;
  ruc?: string;
  apellidos?: string;
  nombres?: string;
  email?: string;
  celular?: string;
  celular2?: string;
  telefonoFijo?: string;

  constructor(object?: Persona) {
    super(object);
  }

  get fullName() {
    return `${this.nombres} ${this.apellidos}`;
  }
}

export class Empresa extends BaseModel {
  ruc?: string;
  nombre?: string;
  rezonSocial?: string;
  direccion?: string;
  email?: string;
  celular?: string;
  celular2?: string;
  telefonoFijo?: string;

  constructor(object?: any) {
    super(object);
  }
}
